import React from 'react'

import Typography from '../Common/Typography'
import Container from '../Common/Container'
import { useTranslations } from '../../hooks/use-translations'

const RegistrySection: React.FC = () => {
  const { t } = useTranslations()
  return (
    <div style={{ paddingTop: '16px' }}>
      <Container>
        <Typography variant="body1" color="gray">
          {t('registry_info')}
        </Typography>
      </Container>
    </div>
  )
}

export default RegistrySection
